import { axiosInstance } from "authProvider";
import { API_URL } from "../../constants";

interface ProductList {
  attributes: {
    name: string;
  };
  id: number;
}
export const getProductlists = () => async (): Promise<ProductList[]> => {
  return await axiosInstance
    .get(`${API_URL}/api/product-lists?populate=*`)
    .then(({ data }) => data.data);
};
